
import { Component, Vue, Prop } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

/**
 * HTMLエディタ用のメニューボタン
 */
@Component({
  components: {
    ButtonBase,
  },
})
export default class ButtonEditorMenu extends Vue {
  /** ボタンのアクティブ状況 */
  @Prop({ default: false })
  isActive!: boolean

  /** ボタンの無効化設定 */
  @Prop({ default: false })
  isDisabled!: boolean

  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
